module.exports = __webpack_public_path__ + "static/CleverGroup-111e2cac215175da6677ed2183c09462.png";